import { GatewayAbstractService } from '@/services/gateway-abstract-service';

export class ShortUrlService extends GatewayAbstractService {
	makeShortUrl(vdpUrl: string, vin: string, writeupId: number, step = 'customize-deal'): Promise<string> {
		const url = `${vdpUrl}#pp-next/${vin}/${step}/${writeupId}`;

		return this.gatewayServices.get(`short-url?url=${encodeURIComponent(url)}`).then(res => res.data);
	}
}
